<template>
    <div class="sheet_top_overlay" v-if="isShow" :style="styleString" v-clickoutside:action_ClickOutside="{}">
        <span class="title">{{ $t('reservationwindow.reservationmonitor.action_manage_group_title') }}</span>
        <button @click="action_MoveLeft" :disabled="!canLeft">
            <v-icon>mdi-chevron-left</v-icon>
            {{ $t('reservationwindow.reservationmonitor.action_manage_item_move_left') }}
        </button>
        <button @click="action_MoveLeftEnd" :disabled="!canLeft">
            <v-icon>mdi-chevron-double-left</v-icon>
            {{ $t('reservationwindow.reservationmonitor.action_manage_item_move_start') }}
        </button>
        <button @click="action_MoveRight" :disabled="!canRight">
            <v-icon>mdi-chevron-right</v-icon>
            {{ $t('reservationwindow.reservationmonitor.action_manage_item_move_right') }}
        </button>
        <button @click="action_MoveRightEnd" :disabled="!canRight">
            <v-icon>mdi-chevron-double-right</v-icon>
            {{ $t('reservationwindow.reservationmonitor.action_manage_item_move_end') }}
        </button>
        <hr>
        <button @click="action_Setting">
            <v-icon>mdi-cog</v-icon>
            {{ $t('reservationwindow.reservationmonitor.action_manage_item_edit_settings') }}
        </button>
        <button @click="action_Default" style="text-align: left;">
            <v-icon>mdi-restore</v-icon>
            {{ $t('reservationwindow.reservationmonitor.action_manage_item_restore_default') }}
        </button>

    </div>
</template>


<script>
import { deepCopy } from '@/util/deep-copy'
import { sheetState } from '../../../sheet-state'
import { hideGroupMenu, sheetOverlays, showAIMessageEditPopup, showGroupSetting } from '../../../sheet-overlays'
import { sheetFilters, saveColumns, saveGroups } from '../../../sheet-filters'
import { handleRefresh } from '../../../sheet-refresh'

export default {
    data() {
        return {
            sheetState,
            sheetOverlays,
            sheetFilters,
            position: { top: 0, left: 0 }
        }
    },
    watch: {
        mousePosition: {
            deep: true,
            handler: function (newValue) {
                if (newValue) {
                    this.$nextTick(() => {
                        this.updateFrame()
                    })
                }
            }
        },
    },
    computed: {
        isShow: function () {
            return this.sheetOverlays.isShowGroupMenu
        },
        mousePosition: function () {
            return this.sheetOverlays.groupMenuPosition ?? { x: 0, y: 0 }
        },
        styleString: function () {
            // 하다희 - Z-index 값 결정해주세요
            return 'top: ' + this.position.top + 'px;' + ' left: ' + this.position.left + 'px;' + 'z-index: 999;'
        },
        group: function () {
            return {
                _id: this.sheetOverlays.selectedGroup._id,
                isSelected: this.sheetOverlays.selectedGroup.isSelected,
                order: this.sheetOverlays.selectedGroup.order
            }
        },
        canLeft: function () {
            if (this.group.order == 0) { return false }
            let array = deepCopy(this.sheetFilters.groups)
            for (let i = 0; i < array.length; i++) {
                if (array[i].order < this.group.order && array[i].isSelected == true) { return true }
            }
            return false
        },
        canRight: function () {
            let array = deepCopy(this.sheetFilters.groups)
            for (let i = 0; i < array.length; i++) {
                if (array[i].order > this.group.order && array[i].isSelected == true) { return true }
            }
            return false
        }
    },
    methods: {
        action_MoveLeft() {
            this.moveToLeft(this.group)
            hideGroupMenu()
        },
        action_MoveLeftEnd() {
            this.moveToLeftEnd(this.group)
            hideGroupMenu()
        },
        action_MoveRight() {
            this.moveToRight(this.group)
            hideGroupMenu()
        },
        action_MoveRightEnd() {
            this.moveToRightEnd(this.group)
            hideGroupMenu()
        },
        action_Setting() {
            if (this.sheetOverlays.selectedGroup?.isAi) {
                showAIMessageEditPopup(this.sheetOverlays.selectedGroup)
            } else {
                showGroupSetting(this.sheetOverlays.selectedGroup, undefined)
            }
            hideGroupMenu()
        },
        action_Default() {
            this.moveToDefault()
            hideGroupMenu()
        },
        action_ClickOutside() {
            hideGroupMenu()
        },

        // MARK: - Private
        updateFrame() {
            let target = this.$el
            if (!target) {
                this.position = { top: this.mousePosition.y, left: this.mousePosition.x }
            } else {
                let { scrollWidth } = this.sheetState.sheetScrollElement
                let left = (this.mousePosition.x + target.offsetWidth > scrollWidth)
                    ? (this.mousePosition.x - target.offsetWidth)
                    : this.mousePosition.x

                this.position = { top: this.mousePosition.y, left }
            }
        },
        moveToDefault() {
            let gArray = deepCopy(this.sheetFilters.groups)
            gArray.sort((l, r) => {
                return l.sortNum - r.sortNum
            })
            gArray.forEach((g, index) => g.order = index)
            let cArray = deepCopy(this.sheetFilters.columns)
            cArray.sort((l, r) => {
                return l.sortNum - r.sortNum
            })
            cArray.forEach((c, index) => c.order = index)
            this.updateGroups(gArray)
            this.updateColumns(cArray)
        },
        moveToLeft(group) {
            let array = deepCopy(this.sheetFilters.groups)
            array.sort((l, r) => {
                return l.order - r.order
            })
            let target = array.find(g => g._id == group._id)
            let originIndex = array.indexOf(target)
            let targetIndex = originIndex - 1
            if (targetIndex < 0) { targetIndex = 0 }
            if (targetIndex >= 0 && array[targetIndex].isSelected == false) {
                targetIndex -= 1
                if (targetIndex < 0) { targetIndex = 0 }
            }

            array.splice(originIndex, 1)
            array.splice(targetIndex, 0, target)

            array.forEach((g, index) => {
                g.order = index
            })
            this.updateGroups(array)
        },
        moveToLeftEnd(group) {
            let array = deepCopy(this.sheetFilters.groups)
            array.sort((l, r) => {
                return l.order - r.order
            })
            let target = array.find(g => g._id == group._id)
            let originIndex = array.indexOf(target)
            let targetIndex = 0

            array.splice(originIndex, 1)
            array.splice(targetIndex, 0, target)

            array.forEach((g, index) => {
                g.order = index
            })
            this.updateGroups(array)
        },
        moveToRight(group) {
            let array = deepCopy(this.sheetFilters.groups)
            array.sort((l, r) => {
                return l.order - r.order
            })
            let target = array.find(g => g._id == group._id)
            let originIndex = array.indexOf(target)
            let targetIndex = originIndex + 1
            let length = array.length - 1
            if (targetIndex > length) { targetIndex = length }
            if (targetIndex <= length && array[targetIndex].isSelected == false) {
                targetIndex += 1
                if (targetIndex > length) { targetIndex = length }
            }

            array.splice(originIndex, 1)
            array.splice(targetIndex, 0, target)

            array.forEach((g, index) => {
                g.order = index
            })
            this.updateGroups(array)
        },
        moveToRightEnd(group) {
            let array = deepCopy(this.sheetFilters.groups)
            array.sort((l, r) => {
                return l.order - r.order
            })
            let target = array.find(g => g._id == group._id)
            let originIndex = array.indexOf(target)
            let length = array.length - 1
            let targetIndex = length
            if (targetIndex <= length && array[targetIndex].isSelected == false) {
                targetIndex += 1
                if (targetIndex > length) { targetIndex = length }
            }

            array.splice(originIndex, 1)
            array.splice(targetIndex, 0, target)

            array.forEach((g, index) => {
                g.order = index
            })
            this.updateGroups(array)
        },
        updateGroups(array) {
            array.forEach((g, index) => g.order = index)
            let data = {
                hospitalID: this.hospital.selectedHospital._id,
                groups: array
            }
            saveGroups(data)
            handleRefresh()
        },
        updateColumns(array) {
            array.forEach((c, index) => c.order = index)
            let data = {
                hospitalID: this.hospital.selectedHospital._id,
                columns: array
            }
            saveColumns(data)
        }
    }
}
</script>